import { SourcingService } from 'api-clients/monolith';

type AcceptBudgetRecommendationParams = {
  sourcingPurchaseId: string;
  requestBody: {
    // eslint-disable-next-line camelcase
    recommended_budget: number;
  };
};

export function acceptBudgetRecommendation(
  params: AcceptBudgetRecommendationParams,
) {
  const { sourcingPurchaseId, requestBody } = params;

  return SourcingService.patchInternalApiSourcingSourcingPurchasesAcceptRecommendation(
    sourcingPurchaseId,
    requestBody,
  );
}
